import { Schema } from "effect";
import {
  AccountId,
  ConversationId,
  ConversationThreadId,
  ShopperAiIntegrationId,
} from "../../../ids/definitions";
import { ShopperAiIntegrationType } from "../integration/integration";
import { MessageChannel } from "./message";
import { ThreadAnalyticsData, ThreadChannelData } from "./thread/channel-data";

export const ConversationThreadResponse = Schema.Struct({
  id: ConversationThreadId,
  conversationId: ConversationId,
  integrationId: ShopperAiIntegrationId,
  accountId: Schema.optional(AccountId),
  externalThreadId: Schema.optional(Schema.String),
  integrationType: ShopperAiIntegrationType,
  channel: MessageChannel,
  channelData: Schema.NullOr(ThreadChannelData),
  analyticsData: Schema.NullOr(ThreadAnalyticsData),
});

export type ConversationThreadResponse = typeof ConversationThreadResponse.Type;

export const ConversationThreadCursor = Schema.Struct({
  id: ConversationThreadId,
});
export type ConversationThreadCursor = typeof ConversationThreadCursor.Type;
